import { render, staticRenderFns } from "./MetricEditModal.vue?vue&type=template&id=28c1a62f"
import script from "./MetricEditModal.vue?vue&type=script&lang=js"
export * from "./MetricEditModal.vue?vue&type=script&lang=js"
import style0 from "./MetricEditModal.vue?vue&type=style&index=0&id=28c1a62f&prod&lang=scss"
import style1 from "./MetricEditModal.vue?vue&type=style&index=1&id=28c1a62f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports